import { render, staticRenderFns } from "./CallTableIssuesReportActions.vue?vue&type=template&id=65e2947c"
import script from "./CallTableIssuesReportActions.vue?vue&type=script&lang=js"
export * from "./CallTableIssuesReportActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports